import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/portfolio-beta-calculator',
  component: () => import('../../routes/PortfolioBetaCalculator.svelte'),
  card: {
    id: 'portfolio-beta-calculator',
    title: 'Portfolio Beta Calculator',
    description: 'Calculate your portfolio\'s overall beta by combining asset betas and weights. Understand systematic market risk using CAPM.',
    icon: 'trending_up',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/portfolio-beta-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Portfolio Beta Calculator – Measure Systematic Market Risk',
    description: 'Free portfolio beta calculator that measures your investment portfolio\'s sensitivity to market movements. Combines asset betas and weights using CAPM to find overall portfolio risk.',
  },
};

export default meta;
